
import React from 'react'
import WithSkeleton from '../../../../components/WithSkeleton'
import { VariablesT, VariableT } from '../../../../types/Company'
import { JobT, RevenueLineItemT } from '../../../../types/Job'
import { TransactionT } from '../../../../types/TransactionT'
import { formatDate, parseFloatTotal } from '../../../../utils/utilsT'

import { Typography, Box, Grid, Card, CardContent, Collapse, Button } from '@mui/material'
import { palette } from '../../../../constants/colors'
import { copyObject } from '../../../../utils'
import RevenueLineItem from '../FinancialTab/RevenueLineItem'
import { RevenueLineItemObj } from '../InitObjectJob'
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { resolveUnitLabel } from '../JobUtils'
import moment from 'moment'

//getVariableValue
export const getVariableValue = (key: string, variables: VariablesT): VariableT | null => {
    return variables[key] ? variables[key] : null
}


export type ILineItemPaymentProps = {
    job: JobT
    index: number
    item: RevenueLineItemT
    companyVariables: VariablesT
    isPaid?: boolean
    refresh?(): Promise<void>
    transaction?: TransactionT
    isLoading?: boolean
}

const LineItemPayment: React.FC<ILineItemPaymentProps> = (props) => {
    const [showFormPayment, setShowFormPayment] = React.useState(false)

    const [item, setItem] = React.useState(copyObject(RevenueLineItemObj));
    const [open, setOpen] = React.useState(false);
    React.useEffect(() => {
        if (props.item) {
            setItem(props.item)
        }

    }, [props.item]);

    // console.log("props.companyVariables", props.companyVariables)
    const revenueItem = (!props.isLoading && props.item) ? getVariableValue(props.item.item, props.companyVariables) : null



    const getDatePaid = React.useCallback(() => {
        return props.transaction ? props.transaction.date : item.date
    }, [props.transaction, item]);


    return (
        <>
            {/* <Card className="mt-1">
            <CardContent> */}

            <Box mt={2} mb={1} pt={2} pb={2} borderBottom="0.38095238095238093px solid #bbb">


                <Grid container spacing={2}>
                    <Grid item xs>
                        <WithSkeleton loading={props.isLoading} propsSkeleton={{ height: 20 }} >
                            <Typography fontWeight="bold">Item</Typography>
                            <Typography fontSize="md" >{revenueItem && revenueItem.verboseName}</Typography>
                        </WithSkeleton>
                    </Grid>

                    <Grid item xs>
                        <WithSkeleton loading={props.isLoading} propsSkeleton={{ height: 20 }} >
                            <Typography fontWeight="bold">Rate{props.item && resolveUnitLabel(props.companyVariables, props.item.item, true)}</Typography>
                            <Typography fontSize="md">{parseFloatTotal(item.rate)}</Typography>
                        </WithSkeleton>
                    </Grid>
                    <Grid item xs>
                        <WithSkeleton loading={props.isLoading} propsSkeleton={{ height: 20 }} >
                            <Typography fontWeight="bold">Units{props.item && resolveUnitLabel(props.companyVariables, props.item.item, false)}</Typography>
                            <Typography fontSize="md">{parseFloatTotal(item.units)}</Typography>
                        </WithSkeleton>
                    </Grid>
                    <Grid item xs>
                        <WithSkeleton loading={props.isLoading} propsSkeleton={{ height: 20 }} >
                            <Typography fontWeight="bold">Total</Typography>
                            <Typography fontSize="md">${parseFloatTotal(item.total)}</Typography>
                        </WithSkeleton>
                    </Grid>
                    {/* <Grid>
                        <Button onClick={(e) => {
                            e.preventDefault()
                            setOpen(!open)
                        }}>
                            {open ? <ExpandLess /> : <ExpandMore />}
                        </Button>
                    </Grid> */}
                </Grid>
                
                {/* <Collapse in={open} timeout="auto" unmountOnExit>
                    {props.isPaid && <Grid >
                        <Typography fontSize={"sm"} color={palette.secondary[500]}>Paid on {formatDate(getDatePaid(), "M/DD/YY [at] h:mm.ss A")}.</Typography>
                    </Grid>}
                </Collapse> */}

            </Box>
            {props.isPaid && <Box >
                    <Typography fontSize={"sm"} color={palette.secondary[500]}>Paid on {formatDate(moment.utc( getDatePaid()), "M/DD/YY [at] h:mm.ss A",true)}.</Typography>
                </Box>}
            {/* </CardContent>
        </Card> */}
        </>
    );
}

export { LineItemPayment };